/* Zoonova Merkliste (Favoriten ohne Kundenkonto, gespeichert im Browser)
   - localStorage "zoonova_favorites": Array von Produkt-Handles
   - Herz-Buttons: [data-zoo-fav="<handle>"]
   - Zaehler:      [data-zoo-fav-count]
   - Merkliste:    [data-zoo-fav-list] (Seite /pages/merkliste)
*/
(function () {
  'use strict';

  var KEY = 'zoonova_favorites';
  var LABEL_ADD = 'Zu Favoriten hinzufügen';
  var LABEL_REMOVE = 'Aus Favoriten entfernen';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (h) { return typeof h === 'string' && h.length; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* privater Modus o.ae. */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    write(list);
    return idx === -1;
  }

  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }

  /* ---------- Buttons ---------- */

  function paintButton(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? LABEL_REMOVE : LABEL_ADD);
    var txt = btn.querySelector('[data-zoo-fav-text]');
    if (txt) txt.textContent = active ? 'Gemerkt' : 'Merken';
  }

  function initButtons(root) {
    var scope = root || document;
    var favs = read();
    var buttons = scope.querySelectorAll('[data-zoo-fav]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      paintButton(btn, favs.indexOf(btn.getAttribute('data-zoo-fav')) !== -1);
    }
  }

  function syncHandle(handle, active) {
    var buttons = document.querySelectorAll('[data-zoo-fav="' + handle + '"]');
    for (var i = 0; i < buttons.length; i++) {
      paintButton(buttons[i], active);
    }
  }

  function bump(btn) {
    btn.classList.remove('zoo-fav--bump');
    void btn.offsetWidth; /* Reflow, damit die Animation neu startet */
    btn.classList.add('zoo-fav--bump');
    window.setTimeout(function () { btn.classList.remove('zoo-fav--bump'); }, 400);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-zoo-fav]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-zoo-fav');
    if (!handle) return;
    var active = toggle(handle);
    syncHandle(handle, active);
    bump(btn);
    updateCount();
    document.dispatchEvent(new CustomEvent('zoonova:favorites', { detail: { handle: handle, active: active, list: read() } }));
  }, true);

  /* ---------- Zaehler ---------- */

  function updateCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-zoo-fav-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = String(n);
      els[i].hidden = n === 0;
    }
  }

  /* ---------- Merkliste-Seite ---------- */

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function imageUrl(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function renderEmpty(container) {
    container.innerHTML =
      '<div class="zoo-favlist__empty">' +
      '<p>Deine Merkliste ist leer.</p>' +
      '<a class="zoo-favlist__empty-link" href="/collections/all">Zu den Produkten</a>' +
      '</div>';
  }

  function renderCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = formatMoney(p.price);
    var compare = p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '';
    var url = '/products/' + encodeURIComponent(p.handle);
    return (
      '<article class="zoo-favlist__card" data-zoo-fav-item="' + escapeHtml(p.handle) + '">' +
        '<a class="zoo-favlist__image" href="' + url + '">' +
          (img
            ? '<img src="' + escapeHtml(imageUrl(img, 500)) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
            : '<span class="zoo-favlist__noimage" aria-hidden="true"></span>') +
        '</a>' +
        '<h3 class="zoo-favlist__title"><a href="' + url + '">' + escapeHtml(p.title) + '</a></h3>' +
        '<div class="zoo-favlist__price">' +
          (compare ? '<s class="zoo-favlist__compare">' + compare + '</s> ' : '') +
          '<span>' + price + '</span>' +
        '</div>' +
        '<a class="zoo-favlist__btn" href="' + url + '">zum Produkt</a>' +
        '<button type="button" class="zoo-favlist__remove" data-zoo-fav-remove="' + escapeHtml(p.handle) + '">Entfernen</button>' +
      '</article>'
    );
  }

  function renderList(container) {
    var handles = read();
    if (!handles.length) {
      renderEmpty(container);
      return;
    }
    container.innerHTML = '<div class="zoo-favlist__loading">Merkliste wird geladen …</div>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var html = '';
      var stale = [];
      for (var i = 0; i < products.length; i++) {
        if (products[i] && products[i].handle) {
          html += renderCard(products[i]);
        } else {
          stale.push(handles[i]);
        }
      }
      /* Nicht mehr vorhandene Produkte still aus der Liste entfernen */
      if (stale.length) {
        write(read().filter(function (h) { return stale.indexOf(h) === -1; }));
        updateCount();
      }
      if (!html) {
        renderEmpty(container);
        return;
      }
      container.innerHTML = '<div class="zoo-favlist__grid">' + html + '</div>';
    });
  }

  function initList() {
    var container = document.querySelector('[data-zoo-fav-list]');
    if (!container) return;
    document.documentElement.classList.add('zoo-has-favlist');
    renderList(container);

    container.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-zoo-fav-remove]') : null;
      if (!btn) return;
      event.preventDefault();
      var handle = btn.getAttribute('data-zoo-fav-remove');
      remove(handle);
      syncHandle(handle, false);
      updateCount();
      var card = btn.closest('[data-zoo-fav-item]');
      if (card) card.remove();
      if (!container.querySelector('[data-zoo-fav-item]')) renderEmpty(container);
    });
  }

  /* ---------- Start ---------- */

  function init() {
    initButtons();
    updateCount();
    initList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-Editor / dynamisch nachgeladene Sektionen (Section Rendering API) */
  document.addEventListener('shopify:section:load', function (e) { initButtons(e.target); });
  var mo = window.MutationObserver ? new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-zoo-fav') || n.querySelector('[data-zoo-fav]'))) {
          initButtons(n);
        }
      }
    }
  }) : null;
  if (mo) mo.observe(document.documentElement, { childList: true, subtree: true });

  /* Zwischen Tabs synchron halten */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      initButtons();
      updateCount();
      var c = document.querySelector('[data-zoo-fav-list]');
      if (c) renderList(c);
    }
  });

  window.ZoonovaFavorites = { read: read, has: has, toggle: toggle, remove: remove, refresh: init };
})();
